import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from '../../../styles/colors';
import { ZeeFontBold } from '../../../styles/font';
import { flex } from '../../../styles/utils';

export const active = css`
  background-color: ${colors.PrimaryWhiteColorAlpha06};
  z-index: 1;
`;

export const activeBox = css`
  border-color: ${colors.PurpleLight};
`;

export const row = css`
  width: 100%;
  ${flex('row', 'start', 'center')};
  border-radius: 8px;
  padding: 0px;
  border-top: 1px solid ${colors.AppBgColor};
  border-bottom: 1px solid ${colors.AppBgColor};
  &:hover {
    background-color: ${colors.PrimaryWhiteColorAlpha06};
    //required here changing the color of checkbox
    label div:last-of-type {
      border-color: ${colors.PurpleLight};
    }
  }
`;
export const label = css`
  width: 100%;
  height: 100%;
  padding: 12px 12px;
  cursor: pointer;
  ${flex('row', 'space-between', 'center')};
  ${ZeeFontBold(14, 15)};
`;
export const commonName = css`
  padding-left: 20px;
  color: ${rgba(colors.NavMenuTextColor, 0.5)};
`;
export const langName = css`
  padding-left: 18px;
`;

export const dot = css`
  background: ${colors.white};
  border-radius: 50%;
  height: 6px;
  width: 6px;
`;

export const languageContainer = css`
  ${flex('row', 'flex-start', 'center')};
`;

export const checkBox = css`
  display: none;
`;

export const radioOuter = css`
  border: 1px solid ${colors.RadioCheckBorderColor};
  border-radius: 7px;
  height: 14px;
  width: 14px;
  margin: 4px 0px;
  position: relative;
`;

export const radioInner = css`
  width: 8px;
  height: 8px;
  background-color: ${colors.PurpleLight};
  border-radius: 4px;
  left: 2px;
  top: 2px;
  position: absolute;
`;

export const Row = styled.div`
  ${row};
`;
export const Label = styled.label`
  ${label}
`;
export const RadioButton = styled.input`
  ${checkBox};
`;
